import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card } from 'react-bootstrap';
import { useLocation, Navigate, Link, useNavigate } from 'react-router-dom';
import { formatMoeda } from '../../utils/utils';
import { useEffect, useState } from 'react';
import auxService from '../../services/AuxService';

interface QrCodeProps {
    qrcode: string;
    image: string;
    documento: string;
    valor: number;
    tipo: 'assinatura' | 'licenca'
}

const AssinaturaQrcode = () => {
    const location = useLocation();
    const state = location.state as QrCodeProps | null;
    const [timeLeft, setTimeLeft] = useState(360); //2:30min
    const navigate = useNavigate();

    useEffect(() => {
        const countdownInterval = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(countdownInterval);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(countdownInterval);
    }, []);

    useEffect(() => {
        const requestInterval = setInterval(() => {
            auxService.getStatusAssinatura(documento)
                .then(res => {
                    if (res?.status === 'CONCLUIDA') {
                        navigate('/dashboard');
                    }
                }).catch(error => {
                    console.log(error);
                });
        }, 5000);

        return () => clearInterval(requestInterval);
    }, []);

    if (!state) {
        return <Navigate to="/" />;
    }

    const { qrcode, image, documento, valor, tipo } = state;

    const formatTime = (seconds: number) => {
        const min = String(Math.floor(seconds / 60)).padStart(2, '0');
        const sec = String(seconds % 60).padStart(2, '0');
        return `${min}:${sec}`;
    };

    const copyToClipboard = () => {
        if (qrcode.trim() === "") return; // evita copiar vazio
        navigator.clipboard.writeText(qrcode)
            .then(() => {
                alert("Texto copiado!");
            })
            .catch(err => {
                console.error("Erro ao copiar: ", err);
            });
    };

    return (<div className=" d-flex justify-content-center align-items-center ">
        <div className=" col-md-4 mt-4">
            <Card>
                <Card.Header>
                    <h6 className='text-center mb-0'>{formatTime(timeLeft)}</h6>
                </Card.Header>
                <Card.Body>
                    <input type="hidden" name="documento" value={documento} />
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group text-center">
                                <img width="200" height="200"
                                    src={image}
                                    alt="QRCode" />
                                <br />
                            </div>
                        </div>
                    </div>
                    <div className="row d-flex justify-content-center">
                        <div className="col-md-12">
                            <h4 className='text-center'>{formatMoeda(valor)}</h4>
                        </div>
                    </div>
                    <div className="row d-flex justify-content-center">
                        <div className="col-md-12">
                            <div className="input-group mb-3">
                                <input type="text" className="form-control form-control-sm" value={qrcode} readOnly />
                                <button className="btn btn-primary btn-sm" onClick={copyToClipboard}
                                    type="button" id="button-addon2" style={{ fontSize: 'small' }}>
                                    <i className="fas fa-copy"> Copiar Link</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </Card.Body>
                <Card.Footer className=''>
                    <div className="d-flex justify-content-between">


                        {tipo === 'assinatura' ? (
                            <Link to="/assinatura" className="btn btn-secondary me-2">
                                <FontAwesomeIcon icon={faArrowLeft} /> Voltar
                            </Link>
                        ) : (
                            <Link to="/licenca" className="btn btn-secondary me-2">
                                <FontAwesomeIcon icon={faArrowLeft} /> Voltar
                            </Link>
                        )}

                        <Link to="/dashboard" className="btn btn-primary">
                            Efetue o pagamento
                        </Link>
                    </div>
                </Card.Footer>
            </Card>
        </div>
    </div>)
}

export default AssinaturaQrcode;